module.exports = __webpack_public_path__ + "static/media/BBO4OF5GLRHEFBEIONGSQK6R2Q.3e61631a.jpg";